<template>
  <div >
    <div class="error-box">
      <div class="error-title">{{errorMsg}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-error-page',

  props: {
    errorMsg: String,
  },

  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.error-box {
  width: 600px;
  border-radius: 15px;
  margin: auto;
  margin-top: 100px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.21);
  background-color: #ffffff;
  padding: 50px 70px;
}

.error-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 30px;
  color: $primary-color;
}
</style>